// = Libs =
import { FC } from 'react';
import { IconProps } from '@/common/components/icons/icon.types';

// = Constants =
import COLORS from '@/constants/colors';

const DeleteIcon: FC<IconProps> = ({ color = 'dark' }) => {
  const iconColor = COLORS[color];

  return (
    <svg viewBox="0 0 30 30" xmlns="http://www.w3.org/2000/svg">
      <path
        d="M23.0429 8.71961C23.4334 8.32908 23.4334 7.69592 23.0429 7.30539L22.6946 6.95711C22.3041 6.56658 21.6709 6.56658 21.2804 6.95711L15 13.2375L8.71961 6.95711C8.32908 6.56658 7.69592 6.56658 7.30539 6.95711L6.95711 7.30539C6.56658 7.69592 6.56658 8.32908 6.95711 8.71961L13.2375 15L6.95711 21.2804C6.56658 21.6709 6.56658 22.3041 6.95711 22.6946L7.30539 23.0429C7.69592 23.4334 8.32908 23.4334 8.71961 23.0429L15 16.7625L21.2804 23.0429C21.6709 23.4334 22.3041 23.4334 22.6946 23.0429L23.0429 22.6946C23.4334 22.3041 23.4334 21.6709 23.0429 21.2804L16.7625 15L23.0429 8.71961Z"
        fill={iconColor}
      />
    </svg>
  );
};

export default DeleteIcon;
